<template>
  <v-dialog
    :value="dialog"
    :overlay-opacity="0.6"
    overlay-color="#0d0d0d"
    content-class="booking-dialog"
    transition="scroll-y-reverse-transition"
    persistent
  >
    <div class="booking-dialog-container">
      <icon name="briefcase" class="dialog__icon"></icon>
      <div class="dialog__title">Buchungen bald verfügbar</div>
      <div
        class="dialog__text"
      >Das System zur Buchung wird in Kürze zur Verfügung stehen. Bitte schreiben Sie bei Interesse bis dahin einfach eine E-Mail.</div>
      <div class="dialog__tag">
        <icon name="mail" class="dialog__tag-icon"></icon>
        <a
          class="dialog__mail dialog__tag-text"
          href="mailto:info@auszeit-weinreisen.de"
        >info@auszeit-weinreisen.de</a>
      </div>
      <div>
        <button class="dialog__button" @click="close()">Okay</button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Icon from "../../../core/components/icon/Icon";

export default {
  name: "BookingDialog",
  props: {
    dialog: Boolean
  },
  methods: {
    close() {
      this.$emit("close");
    }
  },
  components: {
    Icon
  }
};
</script>

<style lang="scss">
.booking-dialog.v-dialog {
  width: 100%;
  max-width: 560px;
}

.booking-dialog-container {
  border-radius: 16px;
  background-color: #ffffff;
  padding: 52px 60px 32px;
  height: 100%;
}

.dialog__icon {
  max-width: 100px;
  max-height: 100px;
  min-width: 100px;
  min-height: 100px;
  border-radius: 50%;
  background-color: #f1e4f6;
  font-size: 44px;
  color: #6d0b9b;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 32px;
}

.dialog__title {
  line-height: 32px;
  font-family: "Playfair Display";
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.3px;
  text-align: center;
  color: #0d0d0d;
  margin-bottom: 8px;
}

.dialog__text {
  line-height: 23px;
  //font-family: SoleilLt;
  font-family: Lato;
  font-weight: 300;
  font-size: 18px;
  letter-spacing: 0.23px;
  text-align: center;
  color: #4d4d4d;
  margin-bottom: 32px;
}

.dialog__tag {
  max-width: 290px;
  margin: 0 auto 32px;
  height: 40px;
  border-radius: 4px;
  background-color: rgba(204, 204, 204, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;

  &-icon {
    color: #4d4d4d;
    font-size: 18px;
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }

  &-text {
    line-height: 23px;
    //font-family: SoleilLt;
    font-family: Lato;
    font-weight: 300;
    font-size: 18px;
    letter-spacing: 0.23px;
    color: #4d4d4d;
  }
}

.dialog__mail {
  text-decoration: none;
  color: #4d4d4d !important;
}

.dialog__button {
  padding: 10px 24px;
  border-radius: 4px;
  background-color: #0d0d0d;
  line-height: 24px;
  //font-family: Soleil;
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.8px;
  color: #ffffff;
  text-transform: uppercase;
}

@media (max-width: 767px) {
  .booking-dialog.v-dialog {
    max-width: unset;
    max-height: none !important;
    align-self: flex-end;
    min-width: 100%;
    max-width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: 0;

    .booking-dialog-container {
      padding: 56px 24px 32px;
      margin: 64px 0 0 0;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      min-height: calc(100% - 64px);
      height: fit-content;
    }
  }
}
</style>
